import axios from "axios";
import { Notification, MessageBox } from "element-ui";
import router from "@/router";

axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";
import { getToken, removeToken } from "@/utils/auth";
// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  // timeout: 5000,
  withCredentials: true,
});
// 请求拦截
service.interceptors.request.use(async (config) => {
  // 是否需要设置 token
  if (config.headers.isToken) {
    config.headers["Authorization"] = "Bearer " + getToken();
  }
  let {
    is: isDel = false,
    content = "此操作将永久删除该文件, 是否继续?",
    title = "提示",
  } = config.warning || {};
  if (config.method == "delete" || isDel) {
    await MessageBox.confirm(content, title, { type: "warning" });
  }
  return config;
});
// 响应拦截
service.interceptors.response.use((res) => {
  if (res.data.code == 500) {
    Notification.error({
      title: res.data.msg,
    });
    return Promise.reject();
  } else if (res.data.code == 401) {
    Notification.error({
      title: "登录已过期",
    });
    removeToken();
    return Promise.reject(res.data);
  } else {
    return res.data;
  }
});

export default service;
